import { CheckCircleOutline } from "@mui/icons-material";
import { Alert, AlertTitle, Box, Typography } from "@mui/material";
import { ContentBox } from "components/common/Box";
import theme from "lib/theme";
import { BoxType } from "types/assetRetrieval";
import bulkBoxImage from "assets/images/bulk_box.svg";
import { Grid } from "@mui/material";
import useFeatureFlag from "hooks/useFeatureFlag";

const Helper = ({ boxType }: { boxType: BoxType | null }) => {
  const { enabled: canadaAddressesEnabled } = useFeatureFlag("canada_addresses_enabled");

  return (
    <ContentBox>
      <Box
        sx={{
          ul: { fontSize: "14px", color: theme.palette.text.secondary, mt: 0.5, pl: 3 },
        }}
      >
        <Grid container>
          {boxType === BoxType.desktop && (
            <Grid item xs={12}>
              <Alert
                severity="warning"
                icon={false}
                variant="outlined"
                sx={{ mb: 2, color: theme.palette.warning.main }}
              >
                <AlertTitle sx={{ fontWeight: 600 }}>Not suitable for iMacs</AlertTitle>
                The box is designed for standard desktops. iMacs are larger and they may be harder to fit into this
                desktop box.
              </Alert>
            </Grid>
          )}
          <Grid item xs={12} display="flex" alignItems="center" gap={1}>
            <CheckCircleOutline color="primary" />
            <Typography fontWeight="bold">What's Included?</Typography>
          </Grid>
        </Grid>
        <Grid container>
          <Grid item xs={12} lg={boxType === BoxType.bulk ? 8 : 12}>
            <ul>
              {boxType === BoxType.bulk && (
                <>
                  <li>The box allows 10 laptops or tablets. No mobile phones or monitors allowed.</li>
                  <li>Padded laptop box, pre-printed shipping label, easy instructions, and tape</li>
                </>
              )}
              {boxType !== BoxType.bulk && (
                <li>A padded box, pre-printed shipping label, easy instructions, and tape</li>
              )}
              <li>Custom email communications with your employee, including reminders if they delay returns</li>
              <li>Tracking updates sent to your company email address</li>
              <li>Shipments to all US states {canadaAddressesEnabled ? "or Canada provinces" : ""}</li>
              <li>3-5 business day delivery time</li>
            </ul>
          </Grid>

          {boxType === BoxType.bulk && (
            <Grid item xs={12} lg={4} display="flex" justifyContent="end">
              <img src={bulkBoxImage} alt="bulk box" width="180px" height="180px" style={{ paddingLeft: "15px" }} />
            </Grid>
          )}
        </Grid>
      </Box>
    </ContentBox>
  );
};

export default Helper;
